import { Component, OnDestroy, AfterViewInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'ngx-tiny-mce',
  template: '',
})
export class TinyMCEComponent implements OnDestroy, AfterViewInit {

  @Output() editorKeyup = new EventEmitter<any>();

  editor: any;
  private editorApi: any;
  private destroyed = false;

  constructor(
    private host: ElementRef,
    private locationStrategy: LocationStrategy,
  ) { }

  async ngAfterViewInit() {
    await import('tinymce/tinymce');
    await import('tinymce/themes/modern/theme');
    await Promise.all([
      import('tinymce/plugins/link/plugin'),
      import('tinymce/plugins/paste/plugin'),
      import('tinymce/plugins/table/plugin'),
    ]);

    if (this.destroyed) return;

    this.editorApi = (window as any).tinymce;
    if (!this.editorApi) return;

    this.editorApi.init({
      target: this.host.nativeElement,
      plugins: ['link', 'paste', 'table'],
      skin_url: `${this.locationStrategy.getBaseHref()}assets/skins/lightgray`,
      setup: editor => {
        this.editor = editor;
        editor.on('keyup', () => {
          this.editorKeyup.emit(editor.getContent());
        });
      },
      height: '320',
    });
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.editor) {
      this.editorApi?.remove(this.editor);
    }
  }
}
